import { render, staticRenderFns } from "./UserCategory.vue?vue&type=template&id=49f44528&scoped=true&"
import script from "./UserCategory.vue?vue&type=script&lang=js&"
export * from "./UserCategory.vue?vue&type=script&lang=js&"
import style0 from "./UserCategory.vue?vue&type=style&index=0&id=49f44528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f44528",
  null
  
)

export default component.exports